module.exports = __webpack_public_path__ + "static/media/Bkkins.svg-1-1024x216.029f5543.png";